import { combine, withCallback, withContext } from 'react-hooks-combine'
import { ServicesContext } from 'services/context'
import { withTableController } from 'shared/hooks'
import { StoreContext } from 'store/context'

import FavoriteButtonComponent from './component'

export const allBeneficiariesFavorite = combine(
  withTableController({ id: 'beneficiaries-table' }),
  withContext('appStore', StoreContext),
  withContext(
    'followerService',
    ServicesContext,
    ({ followerService }) => followerService
  ),
  withCallback(
    'onFavoriteButton',
    ({ followerService, table }, { value }) =>
      () => {
        if (!value.followed) {
          return followerService
            .addFollowers({
              beneficiaryIds: [value.id],
            })
            .then(() => table.refresh())
        }
        return followerService
          .removeFollowers({ beneficiaryIds: [value.id] })
          .then(() => table.refresh())
      },
    ['value']
  )
)(FavoriteButtonComponent)
